import React from 'react';
import { Building2, Handshake, Image as ImageIcon } from 'lucide-react';
import { partnerSchools } from '../data/partners';

const OurPartners = () => (
  <section className="partners-section section-padding" id="partners" data-testid="partners-section">
    <div className="partners-shell">
      <div className="partners-intro">
        <div className="section-eyebrow"><Handshake size={15} /> Our Partners</div>
        <h2>Growing with schools that care about every student.</h2>
        <p>
          MindVrik works with schools to make career awareness, screening, and guidance accessible to their students.
        </p>
      </div>

      {partnerSchools.length ? (
        <div className="partner-logo-grid">
          {partnerSchools.map((partner) => (
            <article className="partner-logo-card" key={partner.name}>
              {partner.logo ? (
                <img src={partner.logo} alt={`${partner.name} logo`} />
              ) : (
                <Building2 size={30} aria-hidden="true" />
              )}
              <strong>{partner.name}</strong>
            </article>
          ))}
        </div>
      ) : (
        <div className="partners-empty-state">
          <ImageIcon size={28} aria-hidden="true" />
          <div>
            <strong>Partner school logos will appear here.</strong>
            <p>We are currently onboarding our partner schools. Please check back later.</p>
          </div>
        </div>
      )}
    </div>
  </section>
);

export default OurPartners;
